// extracted by mini-css-extract-plugin
export default {"wrapper":"feed-page_wrapper__5H12p"};